import { ArrowRight } from 'lucide-react';

export default function CTA() {
  return (
    <section id="contato" className="relative overflow-hidden py-20 md:py-28 bg-brand-azul text-white">
      <div className="absolute -top-24 -right-24 w-[440px] h-[440px] rounded-full bg-brand-roxo/40 blur-3xl" aria-hidden />
      <div className="absolute -bottom-24 -left-24 w-[380px] h-[380px] rounded-full bg-brand-rosa/20 blur-3xl" aria-hidden />

      <div className="container px-4 mx-auto relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-5xl font-extrabold mb-5 leading-tight">
            Pronto para deixar o <span className="text-brand-rosa">acaso</span> fora das compras?
          </h2>
          <p className="text-lg md:text-xl mb-10 text-white/80 max-w-2xl mx-auto leading-relaxed">
            Escolha um plano, conecte seus WhatsApps e comece a economizar em poucos dias.
          </p>
          <a
            href="#planos"
            className="inline-flex items-center gap-2 px-8 py-4 bg-brand-rosa text-brand-azul font-bold rounded-full hover:brightness-105 transition shadow-lg shadow-brand-rosa/20"
          >
            Ver planos <ArrowRight size={20} />
          </a>
          <p className="mt-6 text-sm text-white/60">
            Sem cartão para testar. Cancele quando quiser.
          </p>
        </div>
      </div>
    </section>
  );
}
